import React, { memo } from "react";
import styled from "styled-components";
import { CommercialTitle } from "./commercial-title";
import { CommercialText } from "./commercial-text";
import { GolTooltip } from "../tooltip/tooltip";
import { CommercialService } from "../../services/commercial-service";
import { IDisabled } from "../../types";

interface IMenuOfferCommonProps {
  commercialService: CommercialService;
  children: JSX.Element;
  disabled?: boolean;
}

const CommercialWrapper = styled.div<IDisabled>`
  position: relative;
  width: 298px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 12px 14px;
  margin: 2px;
  background-color: ${(props) => props.theme.backgroundColor};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TitleGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Legend = styled.div`
  width: 100%;
  text-align: left;
  font-size: 12px;
  color: ${(props) => props.theme.disabledColor};
  margin-top: -8px;
  margin-bottom: 8px;
`;

const CommercialImage = styled.div`
  width: 100%;
`;

const Common = (props: IMenuOfferCommonProps) => {
  return (
    <CommercialWrapper
      className={props.disabled ?? false ? "disabled" : undefined}
      disabled={props.disabled ?? false}
      data-test={`menu-offer-wrapper-${props.commercialService.id}`}
    >
      {props.commercialService.image && <CommercialImage />}
      <TitleGroup>
        <CommercialTitle
          data-test="menu-offer-title"
          title={props.commercialService.name}
        />
        <GolTooltip
          title={props.commercialService.name}
          text={props.commercialService.description}
        />
      </TitleGroup>
      {props.commercialService.hasPrepayment && (
        <Legend data-test="menu-offer-prepayment-infos">
          {props.commercialService.prepaymentInfos}
        </Legend>
      )}
      <CommercialText
        data-test="menu-offer-description"
        text={props.commercialService.description}
      />
      {props.children}
    </CommercialWrapper>
  );
};

export const MenuOfferCommon = memo(Common);
